<template>
    <div class="level-selector">
      <a-select v-model="showLevel" style="width: 100%;" @select="onSelect">
        <a-select-option v-for="levelSelector in levels" :value="levelSelector.value" :key="levelSelector.value">
          {{ levelSelector.name }}
        </a-select-option>
      </a-select>
    </div>
</template>

<script>
import '../config/global'
const axios = require('axios')
export default {
  name: 'LevelSelector',
  props: ['level', 'levels', 'chatroomname'],
  data () {
    return {
      editChatroomExtUrlPostFix: 'UChatroom/edit_chatroom_ext',
      showLevel: this.level
    }
  },
  computed: {
    editChatroomExtUrl: function () {
      return global.DOMAIN + global.API_VERSION + this.editChatroomExtUrlPostFix
    }
  },
  watch: {
    level: function () {
      this.showLevel = this.level
    }
  },
  methods: {
    onSelect (value, option) {
      // console.log('onSelect', value, option)
      let level = this.levels.find(item => item.value === value)
      if (level) {
        this.setLevel(level)
      }
    },
    setLevel (level) {
      axios.post(this.editChatroomExtUrl, {
        level: level.value,
        chatroomname: this.chatroomname,
        token: sessionStorage.token
      }).then((data) => {
        console.log('data.err_code:', data.data.err_code)
        if (data.data.err_code === 0) {
          console.log('chatroom_ext:', data.data.content.chatroom_ext)
          // let group = data.data.content.group
          // // or can be computed?
          // this.inputValue = group.group_name
          // this.editable = false
          // this.emitAddGroup(group)
        } else if (data.data.err_code === 50002) {
          console.log('token 不对，跳转登录')
          this.$router.push('/')
        }
      })
    }
  }
}
</script>

<style scoped>

</style>
